import React, { useState, useEffect, Fragment } from "react";
import { Row, Collapse } from "reactstrap";
import { InvestSubAssetClassTable } from "./InvestSubAssetClassTable/InvestSubAssetClassTable";
import arrow from "../../../../public/svg/keyboard_arrow_down.svg";
import { toPascalCase } from "../../../utils/helper";
import { FundsAssetTable } from "../FundsTable/FundsAssetTable/FundsAssetTable";

import style from "./InvestTable.scss";

export const InvestTable = ({ titulo, offers = [], funds = [], toggle, destacada = false }) => {
  const [bonds, setBonds] = useState([]);
  const [cdas, setCDAs] = useState([]);
  const [equities, setEquities] = useState([]);
  const [options, setOptions] = useState([]);
  const [mFunds, setMFunds] = useState([]);
  const [repo, setRepo] = useState([]);
  const [openSections, setOpenSections] = useState({
    Todos: true,
    Bonos: false,
    CDAs: false,
    Acciones: false,
    Opciones: false,
    mFondos: false,
    Repo: false,
    Fondos: false,
  });

  useEffect(() => {
    // filter offers
    const newBonds = [];
    const newCda = [];
    const newEquities = [];
    const newOptions = [];
    const newFunds = [];
    const newRepo = [];

    offers.map((offerItem) => {
      switch (offerItem.AssetClassForm) {
        case "Bonds":
          if (offerItem.isCDA) {
            newCda.push(offerItem);
          } else {
            newBonds.push(offerItem);
          }
          break;
        case "Equity":
          newEquities.push(offerItem);
          break;
        case "Option":
          newOptions.push(offerItem);
          break;
        case "MFunds":
          newFunds.push(offerItem);
          break;
        case "Repo":
          newRepo.push(offerItem);
          break;
        default:
          break;
      }
    });

    setBonds(newBonds);
    setCDAs(newCda);
    setEquities(newEquities);
    setOptions(newOptions);
    setMFunds(newFunds);
    setRepo(newRepo);
  }, [offers]);

  const titlesInvest = (title, isOpen, toggle) => {
    return (
      <Row className={isOpen ? style.collapseRowOpen : style.collapseRow}>
        <div
          className={isOpen ? style.collapseOpen : style.collapseHeader}
          onClick={() => {
            toggle(title);
          }}
        >
          <span className={isOpen ? style.titleActive : style.title}>{title}</span>
        </div>
      </Row>
    );
  };

  const toggleSection = (section) => {
    setOpenSections((prevState) => {
      const updatedSections = {};
      Object.keys(prevState).forEach((key) => {
        updatedSections[key] = false;
      });
      updatedSections[section] = true;

      return updatedSections;
    });
  };

  return (
    <div className={style.containerOffers}>
      <Row className={style.collapseRowActive}>
        <div className={style.titleRow}>
          {offers.length > 0 && titlesInvest("Todos", openSections.Todos, () => toggleSection("Todos"))}
          {bonds.length > 0 && titlesInvest("Bonos", openSections.Bonos, () => toggleSection("Bonos"))}
          {cdas.length > 0 && titlesInvest("CDAs", openSections.CDAs, () => toggleSection("CDAs"))}
          {equities.length > 0 &&
            titlesInvest("Acciones", openSections.Acciones, () => toggleSection("Acciones"))}
          {options.length > 0 &&
            titlesInvest("Opciones", openSections.Opciones, () => toggleSection("Opciones"))}
          {mFunds.length > 0 &&
            titlesInvest("M. Fondos", openSections.mFondos, () => toggleSection("M. Fondos"))}
          {repo.length > 0 && titlesInvest("Repo", openSections.Repo, () => toggleSection("Repo"))}
          {funds.length > 0 && titlesInvest("Fondos", openSections.Fondos, () => toggleSection("Fondos"))}
        </div>
        <hr className={style.titleDivider} />
      </Row>

      <div className={style.assetRow}>
        {openSections.Todos &&
          (offers.length > 0 || funds.length > 0) &&
          (offers.length > 0 && funds.length <= 0 ? (
            <InvestSubAssetClassTable offers={offers} toggle={toggle} open={openSections.Todos} />
          ) : offers.length <= 0 && funds.length > 0 ? (
            <FundsAssetTable funds={funds} />
          ) : (
            <div>
              <InvestSubAssetClassTable offers={offers} toggle={toggle} open={openSections.Todos} />
              <FundsAssetTable funds={funds} />
            </div>
          ))}
        {openSections.Bonos && bonds.length > 0 && (
          <InvestSubAssetClassTable offers={bonds} toggle={toggle} open={openSections.Bonos} />
        )}
        {openSections.CDAs && cdas.length > 0 && (
          <InvestSubAssetClassTable offers={cdas} toggle={toggle} open={openSections.CDAs} />
        )}
        {openSections.Acciones && equities.length > 0 && (
          <InvestSubAssetClassTable offers={equities} toggle={toggle} open={openSections.Acciones} />
        )}
        {openSections.Opciones && options.length > 0 && (
          <InvestSubAssetClassTable offers={options} toggle={toggle} open={openSections.Opciones} />
        )}
        {openSections.mFondos && mFunds.length > 0 && (
          <InvestSubAssetClassTable offers={mFunds} toggle={toggle} open={openSections.Fondos} />
        )}
        {openSections.Repo && repo.length > 0 && (
          <InvestSubAssetClassTable offers={repo} toggle={toggle} open={openSections.Repo} />
        )}
        {openSections.Fondos && funds.length > 0 && <FundsAssetTable funds={funds} />}
      </div>
    </div>
  );
};
